import React from 'react'
import PropTypes from 'prop-types'
import {
  TieredInterventionContainer,
  TieredInterventionTitle,
  TieredInterventionDescription,
  TieredInterventionFooter,
} from './component.styles'

const TieredInterventionCallout = ({ contentDescription }) => {
  const { title, body, hasFooter, footerChildren } = contentDescription || {}

  return (
    <TieredInterventionContainer>
      <TieredInterventionTitle>{title}</TieredInterventionTitle>
      <TieredInterventionDescription>{body}</TieredInterventionDescription>
      {hasFooter && footerChildren && (
        <TieredInterventionFooter>{footerChildren}</TieredInterventionFooter>
      )}
    </TieredInterventionContainer>
  )
}

TieredInterventionCallout.propTypes = {
  contentDescription: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    hasFooter: PropTypes.bool,
    footerChildren: PropTypes.node,
  }).isRequired,
}

export default TieredInterventionCallout
